import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    QueryList,
    SimpleChanges,
    ViewChildren,
} from '@angular/core';
import { TWO_FACTOR_CODE_LENGTH } from 'src/app/shared/constants/accountSettings.constants';
import { trackByIndex } from 'src/app/shared/utils/track-by.util';

@Component({
    standalone: false,
    selector: 'app-account-otp-input',
    templateUrl: './account-otp-input.component.html',
    styleUrls: ['./account-otp-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountOtpInputComponent implements OnChanges, AfterViewInit {
    @Input() length = TWO_FACTOR_CODE_LENGTH;
    @Input() invalid = false;
    @Input() label = '';
    @Output() codeChange = new EventEmitter<string>();
    @Output() submitted = new EventEmitter<string>();

    @ViewChildren('digitInput')
    private digitInputs!: QueryList<ElementRef<HTMLInputElement>>;

    digits: string[] = new Array(TWO_FACTOR_CODE_LENGTH).fill('');
    readonly trackByIndex = trackByIndex;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['length']) {
            this.digits = new Array(this.length).fill('');
        }
    }

    ngAfterViewInit(): void {
        this.focusDigit(0);
    }

    clear(): void {
        this.digits = new Array(this.length).fill('');
        this.cdr.markForCheck();
        this.focusDigit(0);
    }

    onDigitInput(index: number, event: Event): void {
        const input = event.target as HTMLInputElement;
        const digit = input.value.replace(/\D/g, '').slice(-1);
        input.value = digit;
        this.digits = this.digits.map((value, i) => (i === index ? digit : value));
        this.emitCode();
        if (digit && index < this.length - 1) {
            this.focusDigit(index + 1);
        }
    }

    onDigitKeydown(index: number, event: KeyboardEvent): void {
        if (event.key === 'Backspace' && !this.digits[index] && index > 0) {
            this.focusDigit(index - 1);
            return;
        }
        if (event.key === 'Enter') {
            event.preventDefault();
            const code = this.digits.join('');
            if (code.length === this.length) {
                this.submitted.emit(code);
            }
        }
    }

    onPaste(event: ClipboardEvent): void {
        const pasted = (event.clipboardData?.getData('text') ?? '').replace(/\D/g, '').slice(0, this.length);
        if (!pasted) return;

        event.preventDefault();
        this.digits = this.digits.map((_, i) => pasted[i] ?? '');
        this.emitCode();
        this.focusDigit(Math.min(pasted.length, this.length - 1));
    }

    private emitCode(): void {
        this.codeChange.emit(this.digits.join(''));
    }

    private focusDigit(index: number): void {
        this.digitInputs?.get(index)?.nativeElement.focus();
    }
}
